import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend, Label
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { accessRole } from '../../../../helpers/access_role'
import Select from '../../../../helpers/ui/CustomSelect'
import { AvForm, AvField } from "availity-reactstrap-validation"

import { Link, Redirect } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'
import { cancelToken } from '../../../../services/adapters/kepegawaian/menuService'

import PegawaiSideBar from '../../GlobalComponents/PegawaiSidebar'
import IndexBloc from '../Index/Blocs/IndexBloc'
import CreateBloc from './Blocs/CreateBloc'

let peg_uuid = JSON.parse(localStorage.getItem('userdata')) != null ? JSON.parse(localStorage.getItem('userdata')).employee_uuid : "";
if(accessRole('approve')){
    peg_uuid = JSON.parse(localStorage.getItem('employeeSelected')) != null ? JSON.parse(localStorage.getItem('employeeSelected')).employee_uuid : "";
}

const satuanWaktu = [
    { value: 'Hari', label: 'Hari'},
    { value: 'Minggu', label: 'Minggu'},
    { value: 'Bulan', label: 'Bulan' },
]

class CreateView extends Component {

    source
    createBloc = new CreateBloc();
    indexBloc = new IndexBloc()
    timer

    constructor(props) {
        super(props)
        this.state = {
            typeOption: [],
            signatoriesOption: [],
            typeFilter: {
                filter_value: "",
                page_number: 1,
                page_size: 50,
                sort_order: {
                    column: 'paid_leave_type_id',
                    order: 'asc' 
                }
            },
            signatoriesFilter: {
                filter_value: "",
                page_number: 1,
                page_size: 50,
                sort_order: {
                    column: 'signatories_official_id',
                    order: 'asc' 
                }
            } 
        }

    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
              paid_leave_employee_uuid: peg_uuid,
              ...values
            },
            confirm: true
        })
    }

    submitData = async () => {
        await this.createBloc.fetchCreate(this.state.dataForm)
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }


    loadSignatoriesList = async () => {
        let offset = (this.state.signatoriesFilter.page_number-1)*this.state.signatoriesFilter.page_size
        const query = {
            search: this.state.signatoriesFilter.filter_value,
            limit: this.state.signatoriesFilter.page_size,
            offset: offset,
            order: this.state.signatoriesFilter.sort_order.column,
            sort: this.state.signatoriesFilter.sort_order.order,
            status: 1
        }
        await this.indexBloc.fetchSignatoriesList(query, this.source.token)
    }

    loadTypeList = async () => {
        let offset = (this.state.typeFilter.page_number-1)*this.state.typeFilter.page_size
        const query = {
            search: this.state.typeFilter.filter_value,
            limit: this.state.typeFilter.page_size,
            offset: offset,
            order: this.state.typeFilter.sort_order.column,
            sort: this.state.typeFilter.sort_order.order,
            status: 1
        }
        await this.indexBloc.fetchTypeList(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadTypeList()
        this.loadSignatoriesList()
    }

    handleSelectInputChange = value => {
        clearTimeout(this.timer)

        this.state.signatoriesFilter.filter_value = value

        this.timer = setTimeout(() => this.loadSignatoriesList(), 800);
    }

    // setLeaveTime = (date, days) => {
    //     console.log('cek event', date)
    //     console.log('cek time', days)
    //     var result = new Date(date);
    //     console.log('cek res', result)
    //     return result;
    // }

    componentDidMount = () => {
        this.setTokenAPI()

        this.indexBloc.typeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ typeOption: result.data.response.result })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

        this.indexBloc.signatoriesChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ signatoriesOption: result.data.response })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

        this.createBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

    }

    componentWillUnmount = () => {
        this.indexBloc.typeChannel?.unsubscribe()
        this.indexBloc.signatoriesChannel?.unsubscribe()
        this.createBloc.createChannel?.unsubscribe()
    }

    render() {

        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col md="12">
                            <PegawaiSideBar active="cuti" />
                            <Card className="pegawai-rightbar">
                                <CardBody>
                                    <div className="float-end">
                                        <Link to={`?cuti`}>
                                            <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                        </Link>
                                    </div>
                                    <CardTitle>Pengajuan Cuti</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >
                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Jenis Cuti <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="3">
                                                <Select 
                                                    name="paid_leave_type_uuid"
                                                    errorMessage="Pilih Jenis Cuti"
                                                    options={this.state.typeOption}
                                                    optionLabel="paid_leave_type_name"
                                                    optionValue="paid_leave_type_uuid"
                                                    placeholder="Pilih Jenis Cuti"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Alasan Cuti <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="6">
                                                <AvField
                                                    name="paid_leave_reason"
                                                    placeholder="Masukkan Alasan Cuti"
                                                    errorMessage="Masukkan Alasan Cuti"
                                                    type="textarea"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Tanggal Mulai Cuti <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="2">
                                                <AvField
                                                    name="paid_leave_start_date"
                                                    placeholder="Tanggal Mulai"
                                                    errorMessage="Masukkan Tanggal Mulai"
                                                    type="date"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    // onChange={e => this.setLeaveTime(e.target.value, this.state.paid_leave_time)}
                                                    // readOnly={this.state.paid_leave_time ? false : true}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Tanggal Selesai Cuti <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="2">
                                                <AvField
                                                    name="paid_leave_end_date"
                                                    placeholder="Tanggal Selesai"
                                                    errorMessage="Masukkan Tanggal Selesai"
                                                    type="date"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    // readOnly={true}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Alamat Selama Menjalankan Cuti
                                            </Label>
                                            <Col md="6">
                                                <AvField
                                                    name="paid_leave_address"
                                                    placeholder="Masukkan Alamat Selama Menjalankan Cuti"
                                                    errorMessage="Masukkan Alamat Selama Menjalankan Cuti"
                                                    type="textarea"
                                                    className="form-control"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                No Telepon Selama Cuti
                                            </Label>
                                            <Col md="3">
                                                <AvField
                                                    name="paid_leave_address"
                                                    placeholder="Masukkan No Telepon Selama Cuti"
                                                    errorMessage="Masukkan No Telepon Selama Cuti"
                                                    type="text"
                                                    className="form-control"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Atasan <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="4">
                                                <AvField
                                                    name="paid_leave_signatories_official"
                                                    placeholder="Masukkan Atasan"
                                                    errorMessage="Masukkan Atasan"
                                                    type="text"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to={`/kepegawaian/home.html?skcpns`}>
                                                    <Button color="danger" type="button"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>

                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>


                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin data tersebut sudah benar?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to={`/kepegawaian/home.html?cuti`} />
                : null }

            </Fragment>
        )
    }

}

export default CreateView